import React from 'react';

const Error = () => (
  <div>
    <h1>Something has gone wrong. An email has been sent to the admins. Thank you.</h1>
  </div> 
);

export default Error;
